import { Routes } from '@angular/router';
import { requireLoginGuard } from './providers/require-login.guard';

export const routes: Routes = [
  // The Admin Orders packing-slip print view sits outside TabsPage on purpose:
  // it is a document meant to be printed, not a page in the app shell, so it
  // carries none of the header/tab-bar/side-menu chrome those routes get.
  {
    path: 'admin/orders/print',
    loadComponent: () =>
      import('./pages/admin-orders-print/admin-orders-print').then(
        m => m.AdminOrdersPrintPage,
      ),
    canActivate: [requireLoginGuard],
  },
  // Tabs are mounted at the root, so Home is /, the rest /enterprise
  // (no /app/tabs prefix). The product pages and login/signup live inside it
  // too (see tabs-page/routes.ts), so the tab bar shows on them.
  {
    path: '',
    loadChildren: () =>
      import('./pages/tabs-page/routes').then(m => m.TABS_ROUTES),
  },
];
